// extracted by mini-css-extract-plugin
export default {"container":"Selection_container__zZAs0"};